// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"18e983d7","295":"e1c8cc80","419":"5ec7d957","563":"c4dbd648","787":"99e2c5d9","942":"113304d9"}[chunkId] + ".chunk.js";
};